/**
 * ProofBand — a tight band of verifiable, platform-intrinsic method facts,
 * directly under the hero to break the void and set the tone before the
 * seat selector. No fabricated metrics: each item is true by architecture
 * (what the platform guarantees), not a growth/vanity number.
 *
 * Exhibit grammar (K3): rules, not fills. The band is defined by its top/bottom
 * hairline and interior column rules — no surface fill — so it reads as a ruled
 * register rather than a shaded panel. Zero orange atoms (these are structural
 * facts, not the decisive figure).
 */

interface Fact {
  stat: string;
  label: string;
}

const FACTS: Fact[] = [
  { stat: '20', label: 'deterministic engines compute every figure' },
  { stat: '0', label: 'dollar figures the language model invents' },
  { stat: '3', label: 'roles sign the same number before it exports' },
  { stat: '100%', label: 'of figures traced to a source document' },
];

export default function ProofBand() {
  return (
    <section className="border-y border-hairline">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
        <dl className="grid grid-cols-2 divide-hairline md:grid-cols-4 md:divide-x">
          {FACTS.map((f, i) => (
            <div
              key={f.label}
              className={`flex flex-col py-8 ${i % 2 === 1 ? 'pl-6' : 'pr-6'} md:px-6 md:first:pl-0 md:last:pr-0`}
            >
              <dt className="font-mono text-3xl leading-none tracking-tight text-text-primary sm:text-4xl">
                {f.stat}
              </dt>
              <dd className="mt-2 font-body text-sm leading-snug text-text-muted">
                {f.label}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
